import type { GroupResult } from '@progress/kendo-data-query';

export interface IGridGroup<T> extends GroupResult {
  items: T[];
}
